import { useTranslation } from "react-i18next";

import { Notification } from "shared/atoms/Notification";
import { Spinner } from "shared/atoms/Spinner";

interface Props {
  disableBlocking?: boolean;
  children: React.ReactNode;
  className?: string;
  isError: boolean;
  isLoading?: boolean;
}

export const PageContainer: React.FC<Props> = ({
  disableBlocking = false,
  children,
  className,
  isError,
  isLoading,
}) => {
  const { t } = useTranslation();

  if (isError && !disableBlocking) {
    return (
      <Notification variant="danger" style={{ marginTop: "20px" }}>
        {t("errors.generic")}
      </Notification>
    );
  }

  if (isLoading && !disableBlocking) {
    return <Spinner />;
  }

  return <div className={className}>{children}</div>;
};
